export * from './toggle.button.component';
export * from './toggle.item.component';

import {ToggleButtonComponent} from './toggle.button.component';
import {ToggleItemComponent} from './toggle.item.component';

export const TOGGLE_DIRECTIVES = [
    ToggleButtonComponent,
    ToggleItemComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/toggle/index.ts